import { Link } from "react-router-dom";
import { ALL_TOOLS, TOOL_META } from "./routes";

const CONTENT_LINKS = [
  { to: "/free-developer-tools",          label: "Browse all 25+ free dev tools →" },
  { to: "/blog/best-free-dev-tools-2026", label: "Best free dev tools in 2026 →" },
];

export default function RelatedTools({ toolId, t }) {
  const meta = TOOL_META[toolId];
  if (!meta) return null;

  const related = meta.related
    .map(id => ALL_TOOLS.find(tool => tool.id === id))
    .filter(Boolean);

  if (!related.length) return null;

  const iconBgs = [
    { bg: "rgba(240,90,65,0.10)", color: "#F05A41" },
    { bg: "rgba(216,160,86,0.10)", color: "#D8A056" },
    { bg: "rgba(99,215,226,0.10)", color: "#63d7e2" },
    { bg: "rgba(255,180,166,0.10)", color: "#ffb4a6" },
  ];

  return (
    <div style={{
      borderTop: `1px solid ${t.border}`,
      background: t.bgPanel,
      padding: "2rem 1.5rem 2.5rem",
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>

        {/* Header */}
        <div style={{
          display: "flex", alignItems: "center",
          justifyContent: "space-between", gap: 10,
          marginBottom: "1.5rem", flexWrap: "wrap",
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: t.textPrimary, letterSpacing: "-0.03em", margin: 0 }}>
            Related Tools
          </h2>
          <span style={{ fontSize: 12, color: t.textSecondary, fontStyle: "italic" }}>
            {meta.relatedReason}
          </span>
        </div>

        {/* Cards — Stitch style */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 12,
        }}>
          {related.map((tool, i) => {
            const { bg, color } = iconBgs[i % iconBgs.length];
            return (
              <Link key={tool.id}
                to={tool.path}
                aria-label={`Go to ${tool.name}`}
                style={{
                  background: t.bgPanelHead, border: `1px solid ${t.border}`,
                  borderRadius: 12, padding: "20px 18px",
                  cursor: "pointer", transition: "all 0.18s",
                  display: "flex", flexDirection: "column",
                  gap: 12, textDecoration: "none",
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = "rgba(240,90,65,0.35)";
                  e.currentTarget.style.background = t.bgCard;
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = t.border;
                  e.currentTarget.style.background = t.bgPanelHead;
                }}
              >
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: bg, display: "flex",
                  alignItems: "center", justifyContent: "center",
                  fontSize: 18, color, flexShrink: 0,
                  transition: "transform 0.15s",
                }}>
                  {tool.icon}
                </div>
                <div>
                  <div style={{
                    fontSize: 14, fontWeight: 700, color: t.textPrimary,
                    marginBottom: 4, letterSpacing: "-0.01em",
                  }}>
                    {tool.name}
                  </div>
                  <div style={{ fontSize: 12, color: t.textMuted, lineHeight: 1.5, fontFamily: "JetBrains Mono, monospace" }}>
                    {tool.desc}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Content page links */}
        <div style={{ marginTop: 20, paddingTop: 16, borderTop: `1px solid ${t.border}`, display: "flex", gap: 16, flexWrap: "wrap" }}>
          {CONTENT_LINKS.map(link => (
            <Link key={link.to} to={link.to}
              style={{ fontSize: 12, color: t.textAccent, textDecoration: "none", fontWeight: 700, fontFamily: "JetBrains Mono, monospace", transition: "opacity 0.15s" }}
              onMouseEnter={e => { e.currentTarget.style.opacity = "0.75"; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}>
              {link.label}
            </Link>
          ))}
        </div>

      </div>
    </div>
  );
}
